import { render, staticRenderFns } from "./CsaePage.vue?vue&type=template&id=0fd89cff&scoped=true&"
import script from "./CsaePage.vue?vue&type=script&lang=js&"
export * from "./CsaePage.vue?vue&type=script&lang=js&"
import style0 from "./CsaePage.vue?vue&type=style&index=0&id=0fd89cff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd89cff",
  null
  
)

export default component.exports